import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./UI/Header/Header";
import Footer from "./UI/Footer/Footer";
import Home from "./Component/Home/Home";
import ClinicInstruction from "./Component/ClinicInstruction/ClinicInstruction";
import DoctorProfile from "./Component/DoctorProfile/DoctorProfile";
import SearchPage from "./Component/SearchPage/SearchPage";
import { useLayoutEffect } from "react";
import ThankYou from "./Component/ThankYou/ThankYou";
import ClinicList from "./Component/ClinicList/ClinicList";
import Doctor from "./Component/Doctor/Doctor";
// api call
const Wrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(500, 0);
  }, [location.pathname]);
  return children;
};
function App() {
  return (
    // <Router basename="/websites/demosites/align_me">

    <Router basename="/app">
      <Wrapper>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/clinic/:slug" element={<ClinicInstruction />} />
          <Route path="/doctor/:slug" element={<DoctorProfile />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/clinic" element={<ClinicList />} />
          <Route path="/doctor" element={<Doctor />} />
        </Routes>
        <Footer />
      </Wrapper>
    </Router>
  );
}

export default App;
